export default __webpack_public_path__ + "static/media/Gra poszukiwanie skarbu_Sanja.ebfdf245.pdf";